module.exports = __webpack_public_path__ + "static/media/form.2530e94b.jpg";